import { render, staticRenderFns } from "./CRAddressSelectorV2AutocompleteItem.vue?vue&type=template&id=e519d9c8"
import script from "./CRAddressSelectorV2AutocompleteItem.vue?vue&type=script&lang=js"
export * from "./CRAddressSelectorV2AutocompleteItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports